import { IconPhotoOutline18 as PhotoIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const INLINE_IMAGE_REQUEST_EVENT = "thread-inline-image-request"

export const inlineImageCommand: SlashCommandDefinition = {
	key: "inline-image",
	title: "Image",
	aliases: ["logo", "photo", "picture", "screenshot"],
	icon: <PhotoIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).run()
		window.dispatchEvent(new CustomEvent(INLINE_IMAGE_REQUEST_EVENT))
	},
	group: "media",
}
